import { createContext, useContext, useReducer  } from 'react'

const CHANGE_COLOR = "CHANGE_COLOR";

const ThemeContext = createContext()

const themeReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case CHANGE_COLOR :
      return {
        ...state,
        color: payload,
      }
    default:
      return state
  }
}

const ThemeProvider = ({children}) => {
  const [state, dispatch] = useReducer(themeReducer, {
    color: '#fff'
  })

  const changeColor = (color) => {
    dispatch({ type: CHANGE_COLOR, payload: color })
  }
  return (
    <ThemeContext.Provider value={{...state, changeColor}}>
      {children}
    </ThemeContext.Provider>
  )
}

const useTheme = () => {
  const context = useContext(ThemeContext)

  if (context === undefined) {
    throw new Error("エラー発生中")
  }

  return context
}

export {
  ThemeProvider,
  useTheme
};
